<template>
  <div>
    <FormSelect 
      :value="value"
      @input="$emit('input', $event)"
      :field="field"
      :options="aiAgentReportList"
      :loading="reportListLoading"
      placeholder="Select AI Agent Report"
      v-if="!errorLabel && editable"
    />
    <span v-if="!editable">
      {{getLookupName(aiAgentReportList, value)}}
    </span>
    <span class="text-danger" v-if="errorLabel">{{errorLabel}}</span>
  </div>
</template>

<script>
import form from '@/mixins/form'

export default {
  name: "AutomationAIAgentReportField",
  mixins: [form],
  props: {
    field: String,
    value: [Number, String],
    editable: Boolean
  },
  data() {
    return {
      aiAgentReportList: [],
      reportListLoading: false,
      errorLabel: null
    }
  },
  mounted() {
    // Get ai agent report list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.reportListLoading = true
    this.errorLabel = null

    this.$apiService.aiService.getAgentList()
    .then(list => {

      this.aiAgentReportList = []

      list.data.forEach(aiAgent => {
        if(!aiAgent.isActive)
          return

        if(aiAgent.aiAgentReports && aiAgent.aiAgentReports.length > 0) {
          aiAgent.aiAgentReports.forEach(report => {
            this.aiAgentReportList.push({
              value: report.id,
              name: `${aiAgent.name} (${aiAgent.title}) - ${report.name}`
            })
          })
        }
      });

      this.reportListLoading = false
    })
    .catch(err => {
      this.reportListLoading = false
      if(err.response.status == 403)
        this.errorLabel = 'Permission denied to AI agent report list'
      else
        this.errorLabel = 'Error accessing AI agent report list'
    })
  },
  computed: {
  },
  methods: {
    
  }
}
</script>